export const TimeSeriesGrid = {
    ClassNames: {
        POSITIVE_GROWTH: 'e-positive-growth',
        NEGATIVE_GROWTH: 'e-negative-growth',
        OUT_OF_STOCK: 'e-no-stock',
        DISCOUNT_ON: 'e-discount-on',
        DISCOUNT_OFF: 'e-discount-off'
    },
    Colours: {
        POSITIVE_CHANGE: '0, 133, 120',
        NEGATIVE_CHANGE: '172, 61, 114',
        LIGHT_TEXT: '#fff',
        DARK_TEXT: '#2d3047',
    },
    MAX_SATURATION_PERCENT: 10,
    TEXT_COLOUR_SWITCH_PERCENT: 6,
    NOT_CALCULATED_LABEL: 'N/C',
    NOT_CALCULATED_TOOLTIP: 'No Data Collected',
    NUMBER_OF_COLUMNS: 8,
    INDEX_INCREMENT_SIZE: 1,
    MEASURE_NAME_COUNT_PER_UNIT: 'Count per Unit',
    MEASURE_NAME_QUANTITY: 'Quantity',
    MEASURE_NAME_VOLUME: 'Volume',
    MEASURE_NAME_WEIGHT: 'Weight',
    DATE_FORMAT: 'YYYY-MM-DD',
    QUARTER_FOUR: 4,
    QUARTER_ONE: 1,
    JANUARY: 'Jan',
    DECEMBER: 'Dec',
    WEEK_ONE: 1
};
